import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';

export function MergeColumnsInspector({ step, onChange }) {
  const c = step.config || {};
  const sel = c.columns || [];
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Columns to merge (in order)</FieldLabel>
      <MultiCols selected={sel} onChange={(v) => u({ columns: v })} />
      <FieldLabel>Separator</FieldLabel>
      <TextInput mono value={c.sep ?? ' '} onChange={(v) => u({ sep: v })} placeholder=" · " />
      <FieldLabel>Output column</FieldLabel>
      <TextInput mono value={c.target} onChange={(v) => u({ target: v })} placeholder="full_address" />
    </div>
  );
}
